import { useEffect, useState } from "react";
import {
  slugify,
} from "../../data/cmsStore";
import { cmsAdminApi } from "../../api/cmsApi";

export default function AdminPartnerCategoriesPage() {
  const [categories, setCategories] = useState([]);
  const [form, setForm] = useState({ id: "", name: "", slug: "", folder: "", sortOrder: 0 });
  const [editing, setEditing] = useState(false);
  const [error, setError] = useState("");

  const refresh = async () => {
    try {
      setCategories(await cmsAdminApi.listPartnerCategories());
      setError("");
    } catch (e) {
      setError(e.message || "Could not load partner categories");
    }
  };
  useEffect(() => {
    refresh();
  }, []);

  const openCreate = () => {
    setForm({ id: "", name: "", slug: "", folder: "", sortOrder: categories.length });
    setEditing(true);
  };

  const openEdit = (c) => {
    setForm({
      id: c.id,
      name: c.name,
      slug: c.slug || "",
      folder: c.folder || "",
      sortOrder: c.sortOrder ?? 0,
    });
    setEditing(true);
  };

  const onSave = async (e) => {
    e.preventDefault();
    await cmsAdminApi.savePartnerCategory({
      id: form.id || undefined,
      name: form.name.trim(),
      slug: form.slug.trim() || slugify(form.name),
      folder: form.folder.trim(),
      sortOrder: Number(form.sortOrder) || 0,
    });
    setEditing(false);
    await refresh();
  };

  const onDelete = async (id) => {
    if (!window.confirm("Delete this category and all logos inside it?")) return;
    await cmsAdminApi.deletePartnerCategory(id);
    await refresh();
  };

  return (
    <div className="admin-page">
      <header className="admin-page-head">
        <div>
          <h1>Partner Categories</h1>
          <p>Group partner logos (Cybersecurity, Cloud, Networking, etc.).</p>
        </div>
        <button type="button" className="admin-btn admin-btn-primary" onClick={openCreate}>
          <i className="bi bi-plus-lg" /> Add category
        </button>
      </header>
      {error ? <p className="text-danger">{error}</p> : null}

      {editing ? (
        <form className="admin-panel admin-form" onSubmit={onSave}>
          <div className="admin-panel-head">
            <h2>{form.id ? "Edit category" : "New category"}</h2>
            <button type="button" className="admin-btn admin-btn-ghost" onClick={() => setEditing(false)}>
              Cancel
            </button>
          </div>
          <div className="admin-form-grid">
            <label>
              Name
              <input
                required
                value={form.name}
                onChange={(e) =>
                  setForm({
                    ...form,
                    name: e.target.value,
                    slug: form.id ? form.slug : slugify(e.target.value),
                  })
                }
              />
            </label>
            <label>
              Slug
              <input required value={form.slug} onChange={(e) => setForm({ ...form, slug: e.target.value })} />
            </label>
            <label>
              Image folder (optional)
              <input
                value={form.folder}
                onChange={(e) => setForm({ ...form, folder: e.target.value })}
                placeholder="e.g. cybersecurity"
              />
            </label>
            <label>
              Sort order
              <input
                type="number"
                value={form.sortOrder}
                onChange={(e) => setForm({ ...form, sortOrder: e.target.value })}
              />
            </label>
          </div>
          <div className="admin-form-actions">
            <button type="submit" className="admin-btn admin-btn-primary">
              Save category
            </button>
          </div>
        </form>
      ) : null}

      <div className="admin-panel">
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Order</th>
                <th>Name</th>
                <th>Slug</th>
                <th>Folder</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {categories.map((c) => (
                <tr key={c.id}>
                  <td>{c.sortOrder ?? 0}</td>
                  <td>{c.name}</td>
                  <td>
                    <code>{c.slug}</code>
                  </td>
                  <td>{c.folder || "—"}</td>
                  <td className="admin-actions">
                    <button type="button" className="admin-btn admin-btn-sm" onClick={() => openEdit(c)}>
                      Edit
                    </button>
                    <button
                      type="button"
                      className="admin-btn admin-btn-sm admin-btn-danger"
                      onClick={() => onDelete(c.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
